import script from "./AnnouncementsSubpage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AnnouncementsSubpage.vue?vue&type=script&lang=ts&setup=true"

import "./AnnouncementsSubpage.vue?vue&type=style&index=0&id=4ca1ae1d&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ca1ae1d"]])

export default __exports__